var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCharacterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3010_1635)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0625 2C10.2331 2 8.75 3.48306 8.75 5.3125C8.75 7.14194 10.2331 8.625 12.0625 8.625C13.8919 8.625 15.375 7.14194 15.375 5.3125C15.375 3.48306 13.8919 2 12.0625 2ZM6.75 5.3125C6.75 2.37849 9.12849 0 12.0625 0C14.9965 0 17.375 2.37849 17.375 5.3125C17.375 8.24651 14.9965 10.625 12.0625 10.625C9.12849 10.625 6.75 8.24651 6.75 5.3125Z",
    fill: "#6C74B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.625 18.5625V24.1875C16.625 24.378 16.6133 24.5657 16.5907 24.75H18.6012C18.617 24.5646 18.625 24.377 18.625 24.1875V18.5625C18.625 14.9381 15.6869 12 12.0625 12C8.43813 12 5.5 14.9381 5.5 18.5625V24.1875C5.5 24.377 5.50803 24.5646 5.52377 24.75H7.53433C7.51167 24.5657 7.5 24.378 7.5 24.1875V18.5625C7.5 16.0427 9.5427 14 12.0625 14C14.5823 14 16.625 16.0427 16.625 18.5625Z",
    fill: "#6C74B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3010_1635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacterIcon);
export default __webpack_public_path__ + "static/media/character-icon.f014fe74c054be9328c1d94c8724bf42.svg";
export { ForwardRef as ReactComponent };